import React from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import CustomerJotrCard from 'components/Customer/CustomerJotrCard';
import CustomerJotrsModal from 'components/Modals/CustomerJotrsModal';

import {
  openCustomerJotrsModal,
  closeCustomerJotrsModal
} from 'actions';

const CustomerJotrs = ({ jotrs, modalTitle, moreButtonText, showActions }) => {
  const dispatch = useDispatch();
  const jurisdictions = useSelector(state => state.common?.jurisdictions);
  const modalShown = useSelector(state => state.customer?.isCustomerJotrsModalShown ?? false);

  const getPrimary = () => {
    const primaryJotrs = jotrs?.filter(x => x.isPrimary);
    if (primaryJotrs && primaryJotrs.length > 0) {
      return primaryJotrs.sort((a, b) => b.source - a.source)[0];
    }
    return null;
  };

  const getWhd = () => {
    const whdJotrs = jotrs?.filter(x => !x.isPrimary && x.isWithholdingResidence);
    if (whdJotrs && whdJotrs.length > 0) {
      return whdJotrs.sort((a, b) => b.source - a.source)[0];
    }
    return null;
  };

  const primaryJotr = getPrimary();

  const whdJotr = getWhd();

  return (
    <React.Fragment>
      { (jotrs == null || jotrs.length === 0) && <p>N/A</p> }
      { jotrs && jotrs.length > 0 && <div className="customer-jotrs">
        { primaryJotr && <CustomerJotrCard jotr={ primaryJotr } jurisdictions={ jurisdictions } /> }
        { whdJotr && (!primaryJotr || !primaryJotr.isWithholdingResidence) && <CustomerJotrCard jotr={ whdJotr } jurisdictions={ jurisdictions } /> }
        { jotrs?.length > 1 && <button type="button" className="btn btn-link" onClick={ () => dispatch(openCustomerJotrsModal()) }>{ moreButtonText }</button> }
      </div> }
      { modalShown && <CustomerJotrsModal title={ modalTitle } isShown={ modalShown } jotrs={ jotrs } showActions={ showActions } onConfirm={ () => dispatch(closeCustomerJotrsModal()) } />}
    </React.Fragment>
  );
};

CustomerJotrs.propTypes = {
  jotrs: PropTypes.arrayOf(PropTypes.shape),
  modalTitle: PropTypes.string,
  moreButtonText: PropTypes.string,
  showActions: PropTypes.bool
};

CustomerJotrs.defaultProps = {
  jotrs: null,
  modalTitle: 'Tax Residencies',
  moreButtonText: 'Show More Residencies',
  showActions: false
};

export default CustomerJotrs;
